import format from 'date-fns/format';
import { format as FC } from 'currency-formatter';
import { reduce } from 'ramda';
const playerVerbiages = {

    1: '1',
    5: '1 or 2',
    10: '1 or 3',
    17: '1 or 4',
    21: '1, 2, or 4',
    26: '1, 3, or 4',
    14: '1 - 3',
    30: '1 - 4',

    4: '2',
    13: '2 or 3',
    20: '2 or 4',
    29: '2 - 4',

    9: '3',
    25: '3 or 4',

    16: '4'
};

export const formatPlayers = players => playerVerbiages[reduce((acc, elem) => acc + (elem * elem), 0, players)];
export const formatCurrency = (rate) => {
    const { CurrencyCode, Value } = rate;
    const options = {
        code: CurrencyCode || 'USD',
        precision: 2
    };

    switch (options.code) {

        // override the format for certain currencies
        case 'CAD':
            // canadian dollars use the $ sign - make it obvious that it's referencing CAD
            options.format = '%s%v CAD';
            break;
        case 'MXN':
            // mexico pesos use the $ sign - make it obvious that it's referencing MXN
            options.format = '%s%v MXN';
            break;
        case 'AUD':
            // austrailian dollows, use $ sign and make it obvious it's AUD
            options.format = '%s%v AUD';
            break;
        default:
            options.format = '%s%v';
    }

    return FC(Value, options);
};

const preProccessTeeTime = teetime => {
    const time = format(teetime.time, 'h:mm A');
    const golfersFormatted = formatPlayers(teetime.golfers);
    const price = formatCurrency(teetime.greensFees);
    const originalPrice = formatCurrency(teetime.ipo);
    
    const greensFeesCC = teetime.greensFees.CurrencyCode;
    const totalPrice = formatCurrency({ CurrencyCode: greensFeesCC, Value: teetime.totalPrice });
    const transactionFeesPrice = teetime.transactionFees > 0 ? formatCurrency({ CurrencyCode: greensFeesCC, Value: teetime.transactionFees }) : null;

    return { ...teetime, time, golfersFormatted, price, totalPrice, originalPrice, transactionFeesPrice }
}

export default preProccessTeeTime


// WEBPACK FOOTER //
// ./src/lib/preProccessTeeTime.js